import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getAppRegion } from 'reduxModules/app/selector';
import { sendGTMEvent } from 'reduxModules/googleTagManager/action';
import { openSocialWidgetFromFreeTrial } from 'reduxModules/socialWidget/action';
import useGetCurrentDevice from './useGetCurrentDevice';

const ALLOW_REGIONS = ['hk', 'tw'];

const GTM_DATA_PREFIX_NAME_MAP = {
  course: 'course',
  regular_class: 'topic',
};

export default function useGetFreeTrialInfo({ type, id, name, section } = {}) {
  const { t } = useTranslation(['common', 'myLearning']);
  const region = useSelector(getAppRegion);
  const { isPC } = useGetCurrentDevice();

  const link = t('common.socialWidget.account.getFreeTrialUrl');

  const dispatch = useDispatch();

  const dispatchGTMEventAction = () => {
    if (!type) return;

    const namePrefix = GTM_DATA_PREFIX_NAME_MAP[type.toLowerCase()];
    const eventNamePrefix = type.toUpperCase();

    const data = !id
      ? {}
      : {
          [`${namePrefix}Id`]: id,
          [`${namePrefix}Name`]: name,
          section,
        };

    dispatch(
      sendGTMEvent({
        eventName: `${eventNamePrefix}_FREE_TRIAL_CLICK`,
        data,
      }),
    );
  };

  const handleTriggerFreeTrialLink = () => {
    dispatchGTMEventAction();

    if (isPC) {
      dispatch(openSocialWidgetFromFreeTrial());
    } else {
      window.open(link);
    }
  };

  return {
    isAllowFreeTrialRegion: ALLOW_REGIONS.includes(region),
    link,
    buttonText: t('common.freeTrial.cta2'),
    linkText: t('common.freeTrial.cta1'),
    faqTitleText: t('common.faqHelp.Title'),
    faqCTAText: t('common.faqHelp.cta1'),
    unLockLearningTitleText: t('myLearning.getFreeTrial.title', {
      ns: 'myLearning',
    }),
    unlockLearningDescriptionText: t('myLearning.getFreeTrial.description', {
      ns: 'myLearning',
    }),
    dispatchGTMEventAction,
    handleTriggerFreeTrialLink,
  };
}
